<template>
    <v-row>
        <v-col cols="12" sm="6" md="8">
            <slot v-if="$slots.video" name="video" />
            <slot v-else name="text" />
        </v-col>

        <v-col cols="12" sm="6" md="4" class="d-flex flex-column">
            <slot v-if="$slots.video" name="text" />
            <v-spacer v-else />

            <slot v-if="$slots.controls" name="controls" />
        </v-col>
    </v-row>
</template>

<script>
export default {}
</script>
